import React, { useCallback, useRef, useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import TextInput from 'Components/Forms/Elements/TextInput';
import Switch from 'Components/Forms/Elements/Switch';
import Image from 'Pure/Image';
import Logo from 'Pure/Logo';
import bemit from 'Functions/bemit';
import variant from 'Functions/variant';
import DefaultModal from 'Modals/DefaultModal';
import { getTotalServiceAmount, getTTCServiceAmount, isTrue, num, formatNum } from 'Shared/utilities';
export default function AddServiceCard({
  service,
  onChange,
  ...props
}) {
  const _height_ref = useRef();
  const _timeout_ref = useRef();
  const [max_error, setMaxError] = useState();
  const hours_count = num(props.hours_count, 0);
  const id = service.id;
  const max = service.available_stock > 0 ? num(service.available_stock, 0) : ['0', 0].includes(service.daily_stock) ? 0 : num(service.daily_stock, 0) > 0 ? num(service.daily_stock, 0) : undefined;
  const [see_more_modal, setSeeMoreModal] = useState({});
  const [desc_h, setDescH] = useState();
  const handleQuantityChange = useCallback(function ({
    e,
    value,
    name
  }) {
    if (max !== undefined && num(max, 0) < num(value, 0)) {
      setMaxError(true);
    } else {
      setMaxError(false);
    }
    onChange(value, id);
  }, [max, onChange, id]);
  const name = 'qty_' + (service?.id || '-1');
  const subtractQty = useCallback(function (e) {
    if (num(props.value, 0) > 0 === false) return;
    const new_value = String(num(num(props.value, 0) - 1, 0));
    handleQuantityChange({
      e,
      value: new_value,
      name: name
    });
  }, [props.value, name]);
  const addQty = useCallback(function (e) {
    const new_value = String(num(num(props.value, 0) + 1, 0));
    handleQuantityChange({
      e,
      value: new_value,
      name: name
    });
  }, [props.value, name]);
  const handleSwitchToggle = useCallback(function ({
    e,
    value,
    name
  }) {
    const new_value = isTrue(value) ? '1' : '0';
    handleQuantityChange({
      e,
      value: new_value,
      name
    });
  }, []);
  const openSeeMore = useCallback(function (e) {
    setSeeMoreModal({
      open: true,
      trg: e?.target
    });
  }, []);
  const closeSeeMoreModal = useCallback(function (e) {
    setSeeMoreModal({
      open: false,
      trg: undefined
    });
  }, []);
  useEffect(function () {
    if (!_height_ref?.current) return;
    setDescH(_height_ref.current.scrollHeight);
    _timeout_ref.current = window.setTimeout(function () {
      if (!_height_ref?.current) return;
      setDescH(_height_ref.current.scrollHeight);
    }, 500);
    return () => window.clearTimeout(_timeout_ref.current);
  }, [_height_ref, service.description]);
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
    function handleResize() {
      if (!_height_ref?.current) return;
      setDescH(_height_ref.current.scrollHeight);
    }
  }, [service.description]);
  const qty_with_input = service.unit === 'customer_qty';
  const change_qty = qty_with_input ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-input-counter', ['pick-service'].concat(max_error ? ['max-error'] : []))
  }, /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-btn', ['less']),
    onClick: subtractQty,
    disabled: num(props.value, 0) > 0 === false
  }, "- 1"), /*#__PURE__*/React.createElement(TextInput, {
    className: "c-input-counter__input",
    name: name,
    onChange: handleQuantityChange,
    value: props.value,
    status: props.status,
    "safe-value": true,
    int: true,
    inputMode: "numeric",
    min: "1"
  }), /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-btn', ['more']),
    onClick: addQty,
    disabled: max !== undefined && num(props.value, 0) >= max
  }, "+ 1"), max_error ? /*#__PURE__*/React.createElement("span", {
    className: "c-input-counter__max-error"
  }, "Max.", ' ', formatNum(max, '0,0')) : undefined) : /*#__PURE__*/React.createElement(Switch, {
    onChange: handleSwitchToggle,
    value: num(props.value, 0) === 1 // qté de 0 ou 1
    ,
    name: name,
    "left-label": "Sans",
    label: "Avec",
    status: props.status
  });
  const modifiers = (props.bemit || []).slice(0).concat(['service', 'max-h']);
  if (qty_with_input) modifiers.push('service-qty-type-input');
  const description = (service.description || '').split('<p><br></p>').join('<p></p>');
  const see_more = desc_h !== undefined && desc_h > 180 ? true : false;
  const total = getTotalServiceAmount({
    service: service,
    quantity: service.unit === 'customer_qty' ? props.value : 1,
    hours_count: hours_count
  });
  let service_displayed_price = getTTCServiceAmount({
    service: service
  });
  service_displayed_price = num(service_displayed_price);
  service_displayed_price = formatNum(service_displayed_price, '0,0[.]00');
  const output = /*#__PURE__*/React.createElement("div", {
    className: bemit('c-card', modifiers)
  }, props.category?.label ? /*#__PURE__*/React.createElement("h3", {
    className: "c-card__service-category",
    "aria-hidden": props['hide-category'] ? 'true' : undefined
  }, props.category.label) : undefined, /*#__PURE__*/React.createElement("div", {
    className: "c-card__wrapper"
  }, service?.images?.[0] ? /*#__PURE__*/React.createElement("div", {
    className: "c-card__img-container"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "c-card__img c-card__img--services",
    src: variant({
      img: service.images[0],
      size: 900,
      ratio: '16:9'
    }),
    alt: service?._servicetitle?.title
  })) : service?._servicetitle?.default_img?.[0]?.url ? /*#__PURE__*/React.createElement("div", {
    className: "c-card__img-container"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "c-card__img c-card__img--services",
    src: variant({
      img: service._servicetitle.default_img[0],
      size: 900,
      ratio: '16:9'
    }),
    alt: service?._servicetitle?.title
  })) : /*#__PURE__*/React.createElement("div", {
    className: "c-card__img-container"
  }, /*#__PURE__*/React.createElement(Logo, {
    className: "c-card__img default-logo-img"
  })), /*#__PURE__*/React.createElement("div", {
    className: "c-card__content"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "c-card__title"
  }, service._servicetitle?.title), /*#__PURE__*/React.createElement("div", {
    className: bemit('c-card__text', ['service']),
    dangerouslySetInnerHTML: {
      __html: description
    },
    ref: _height_ref
  }), see_more ? /*#__PURE__*/React.createElement(Button, {
    className: "c-card__see-more",
    onClick: openSeeMore
  }, "Lire la suite") : undefined, /*#__PURE__*/React.createElement("div", {
    className: "c-card__link-container\r c-card__link-container--service"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-card__service-price"
  }, service.unit === 'customer_qty' ? 'P.U : ' : undefined, ['per_hour', 'customer_qty'].includes(service.unit) ? service_displayed_price + '€' : undefined, service.unit === 'per_hour' ? ' par heure' : undefined, service.unit === 'per_hour' && hours_count > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, hours_count + 'h'), props.start === 'day' ? ' (Journée)' : props.start === 'morning' ? ' (Matin)' : props.start === 'afternoon' ? ' (Après-midi)' : undefined) : undefined), /*#__PURE__*/React.createElement("div", {
    className: "c-card__service-qty"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-card-action__element"
  }, service.unit === 'customer_qty' ? /*#__PURE__*/React.createElement("label", {
    className: "c-card-action__label"
  }, "Quantit\xE9") : undefined, change_qty), /*#__PURE__*/React.createElement("span", {
    className: "c-card_price"
  }, formatNum(total, '0,0[.]00'), '€'))))), /*#__PURE__*/React.createElement(DefaultModal, {
    open: see_more_modal?.open === true,
    title: service._servicetitle?.title,
    "with-footer-close": false,
    "hide-controls": true,
    bemit: ['simple', 'small'],
    onClose: closeSeeMoreModal
  }, see_more_modal !== undefined ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-card__text', ['service']),
    dangerouslySetInnerHTML: {
      __html: description
    }
  }) : undefined));
  return output;
}
